export default __webpack_public_path__ + "static/media/uncheck_2.1636199b.mp3";